import React from "react";
import { useFormContext } from "react-hook-form";
import PropTypes from "prop-types";
import { getLocalSystemDate } from "../../../utils/dateUtils";
import { FORM_FIELD } from "../../../ui/formTheme";

const EvaluationInput = ({
  label,
  name,
  type = "text",
  placeholder,
  className = "",
  inputClassName = "",
  labelClassName = FORM_FIELD.label,
  readOnly = false,
  disabled = false,
  isRequired = false,
  rules,
  reserveErrorSpace = false,
  errorClassName = FORM_FIELD.errorText,
  ...props
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  // Helper to get nested error
  const getNestedError = (obj, path) => {
    return path.split(".").reduce((acc, part) => acc && acc[part], obj);
  };

  const error = getNestedError(errors, name);
  const today = getLocalSystemDate();
  const field = register(name, rules);
  const errorMessage = error?.message;

  const controlClass = `${FORM_FIELD.control} ${error ? FORM_FIELD.error : ""} ${
    readOnly || disabled ? FORM_FIELD.disabled : FORM_FIELD.enabled
  } ${inputClassName}`;

  return (
    <div className={`${className} min-w-0 max-w-full`}>
      {label && (
        <label className={labelClassName}>
          {label} {isRequired && <span className="text-red-500">*</span>}
        </label>
      )}
      {type === "textarea" ? (
        <textarea
          {...field}
          placeholder={placeholder}
          readOnly={readOnly}
          disabled={disabled}
          className={controlClass}
          {...props}
        />
      ) : (
        <input
          type={type}
          {...field}
          placeholder={placeholder}
          readOnly={readOnly}
          disabled={disabled}
          max={type === "date" ? props.max || today : props.max}
          className={controlClass}
          {...props}
        />
      )}
      {reserveErrorSpace ? (
        <p
          className={`${errorClassName} min-h-[14px] leading-tight ${errorMessage ? "" : "invisible"}`}
          aria-live="polite"
        >
          {errorMessage || "\u00a0"}
        </p>
      ) : errorMessage ? (
        <p className={errorClassName}>{errorMessage}</p>
      ) : null}
    </div>
  );
};

EvaluationInput.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  rules: PropTypes.object,
  reserveErrorSpace: PropTypes.bool,
  errorClassName: PropTypes.string,
};

export default EvaluationInput;
